import styled from "styled-components";
import { useTranslation } from "react-i18next";
import { VioletBlur } from "../../../../assets/images/VioletBlur";
import React, { useEffect, useState } from "react";
import { media } from "../../../../styles/mixins";

export const Solution = ({ image, index, activeCrm }) => {
  const { t } = useTranslation();

  const [imageComponent, setImageComponent] = useState(null);

  useEffect(() => {
    if (
      typeof image === "object" &&
      image !== null &&
      !React.isValidElement(image)
    ) {
      setImageComponent(image[activeCrm] || Object.values(image)[0]);
    } else {
      setImageComponent(image);
    }
  }, [activeCrm, image]);

  return (
    <SolutionContainer>
      <Title>{t(`solutions.solutionText.${index}.title`)}</Title>
      <ImageContainer>
        <BlurBackground>
          <VioletBlur />
        </BlurBackground>
        <ImageWrapper>{imageComponent}</ImageWrapper>
      </ImageContainer>
      <CaptionContainer>
        <Caption>{t(`solutions.solutionText.${index}.caption`)}</Caption>
      </CaptionContainer>
    </SolutionContainer>
  );
};

const SolutionContainer = styled.div`
  display: grid;
  grid-template-areas:
    "title"
    "caption"
    "image";
  gap: 24px;
  justify-items: center;

  ${media.laptop(`
    grid-template-areas: 
      "title image caption";
    grid-template-columns: 1fr 2fr 1fr;
    gap: 48px;
    justify-content: space-between;
    align-items: flex-start;
  `)};
`;

const Title = styled.div`
  grid-area: title;
  font-weight: 700;
  font-size: 24px;
  line-height: 36px;
  text-align: center;

  ${media.laptop(`
    text-align: left;
  `)};
`;

const ImageContainer = styled.div`
  grid-area: image;
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
`;

const BlurBackground = styled.div`
  position: absolute;
  z-index: 1;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
`;

const ImageWrapper = styled.div`
  position: relative;
  z-index: 2;
  max-width: 100%;

  ${media.mobile(`
    svg {
    width: 100%;
    height:  100%;
  }
`)};
`;

const CaptionContainer = styled.div`
  grid-area: caption;
  width: 100%;
`;

const Caption = styled.div`
  text-align: center;

  ${media.laptop(`
    text-align: left;
  `)};
`;
